import React, { useEffect, useState } from 'react';
import { Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';
import { FaBolt } from 'react-icons/fa';
import { motion } from 'framer-motion';

// ✅ Coin Count Animation
const incrementSpeed = 150; // Milliseconds between each increment
const maxCoins = 100; // Final coin count

// ✅ Keyframe Animation for Clapping Hands
const clapAnimation = keyframes`
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.2); }
`;

// ✅ Styled Components for UI
const StyledContainer = styled(Container)`
  background-color: #000;
  color: #FFFFFF;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 20px;
`;

const Logo = styled.img`
  height: 50px;
  margin-bottom: 20px;
`;

const Message = styled.p`
  font-size: 22px;
  font-weight: bold;
  margin: 5px 0;
`;

const CoinsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #1E1E1E;
  border-radius: 12px;
  padding: 10px 15px;
  border: 2px solid #FF7C24;
  font-size: 20px;
  font-weight: bold;
  color: #FFC107;
  margin-top: 10px;
`;

const ClappingHands = styled.div`
  font-size: 50px;
  margin-top: 20px;
  animation: ${clapAnimation} 0.6s infinite alternate ease-in-out;
`;

const ContinueButton = styled(Button)`
  background-color: #FF7C24;
  border-color: #FF7C24;
  font-size: 18px;
  font-weight: bold;
  border-radius: 10px;
  padding: 12px 30px;
  width: 100%;
  max-width: 300px;
  margin-top: 30px;
`;

const PostActivationCoinsEarnedPage = () => {
  const navigate = useNavigate();
  const [coins, setCoins] = useState(0);

  useEffect(() => {
    let interval;
    if (coins < maxCoins) {
      interval = setInterval(() => {
        setCoins((prev) => (prev < maxCoins ? prev + 10 : maxCoins));
      }, incrementSpeed);
    }
    return () => clearInterval(interval);
  }, [coins]);

  const handleContinue = () => {
    navigate('/post-activation-streak-count');
  };

  return (
    <StyledContainer>
      {/* ✅ FinTorro Logo */}
      <Logo src="/assets/fintorro-logo.png" alt="FinTorro Logo" />

      {/* ✅ Exciting Completion Message */}
      <Message>🎉 Exciting!</Message>
      <Message>🎉 You have completed first lesson</Message>

      {/* ✅ Coins Earned Display */}
      <CoinsContainer>
        <FaBolt color="#FFC107" style={{ marginRight: '8px' }} />
        Coins Earned to spend later<span style={{ marginLeft: '6px', color: '#FFD700' }}>{coins}</span>
      </CoinsContainer>

      {/* ✅ Clapping Hands Animation */}
      <ClappingHands>👏</ClappingHands>

      {/* ✅ Continue Button */}
      <ContinueButton onClick={handleContinue}>Continue</ContinueButton>
    </StyledContainer>
  );
};

export default PostActivationCoinsEarnedPage;
